module.exports = __webpack_public_path__ + "Step3_Header_new.f36d898d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/mobile/headers/Step3_Header_new.png
// module id = jyzp
// module chunks = 0